import React from 'react';
import {
  Box,
  InputLabel,
  makeStyles,
  TextField,
} from '@material-ui/core';

import useTranslateText from '../use_translate_text';
import '../../components/dependents/dependents.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
  },
  input: {
    height: '2rem',
    paddingTop: '2px',
    [theme.breakpoints.up('300')]: {
      width: 130,
    },
    [theme.breakpoints.up('576')]: {
      width: 200,
    },
    [theme.breakpoints.up('768')]: {
      width: 130,
    },
    [theme.breakpoints.up('1024')]: {
      width: 160,
    },
  },
  input_priority: {
    width: 80,
  },
  input_comments: {
    width: 490,
    height: 'unset',
    [theme.breakpoints.down('576')]: {
      width: 250,
    },
  },
}));


const TextFieldComponent = (props) => {
  const classes = useStyles(),
        { translateText } = useTranslateText(),
        { id, value, lable, name, inputRef, onChange, required, helperText, error, disabled, className, maxlen, type } = props;

  return (
    <Box className={`dependents-main__formDiv__input_container ${className}`}>
      {lable && <InputLabel required={required} component="legend"
        className={`${classes.label_form} labels mt-3`}>
        {`${translateText(lable)}:`}
      </InputLabel>}
      <TextField
        id={id || 'outlined-required'}
        InputProps={{
          className: classes.input,
        }}
        inputProps={{
          maxLength: maxlen,
        }}
        placeholder=""
        variant="outlined"
        type={type ? type : 'text'}
        autoComplete="new-password"
        name={name}
        value={value}
        inputRef={inputRef}
        onChange={onChange}
        error={error || false}
        helperText={helperText}
        disabled={disabled}

      />
    </Box>
  );
};

export default TextFieldComponent;